export default class StudentCriteria {
  constructor({
    name,
    parentsName
  } = {}) {
    this.name = name
    this.parentsName = parentsName
  }
}
